import React from 'react';
import logo from "@src/assets/images/logo/logo.png"

const Spinner = () => {
  let skin = '';
  try {
    skin = JSON.parse(window.localStorage.getItem("skin"));
  } catch (err) {/*noop*/ }

  return (
    <div className={`fallback-spinner app-loader ${skin === 'dark' ? 'dark-layout' : ''}`}>
      <img className="fallback-logo" src={logo} alt="logo" />
      <div className="loading">
        <div className="effect-1 effects"></div>
        <div className="effect-2 effects"></div>
        <div className="effect-3 effects"></div>
      </div>
    </div>
  );
}

export default Spinner;